import { formatDatumIdo, formatIdo } from '../lib/formaz.ts';

/** A még el nem fogadott meghívó (a `kollegak_meghivo_allapot()` sora). */
export interface Meghivo { user_id: string; kuldve_at: string | null; ervenyes_eddig: string | null }

/** A meghívó linkje ennyi ideig él (Supabase Auth `otp_expiry`, 3600 mp). */
export const MEGHIVO_ERVENYESSEG_PERC = 60;

export type MeghivoKijelzes = { lejart: boolean; szoveg: string };

export function meghivoKijelzes(m: Meghivo, most: Date): MeghivoKijelzes {
  if (!m.kuldve_at || !m.ervenyes_eddig) return { lejart: true, szoveg: 'Még nem fogadta el a meghívót.' };
  const hatra = Math.ceil((new Date(m.ervenyes_eddig).getTime() - most.getTime()) / 60_000);
  if (hatra <= 0) {
    return { lejart: true, szoveg: `A meghívó lejárt (${formatDatumIdo(m.ervenyes_eddig)}). Küldd el újra, és a kolléga egy órán belül fogadja el.` };
  }
  return {
    lejart: false,
    szoveg: `Meghívó elküldve: ${formatDatumIdo(m.kuldve_at)}. Érvényes ${formatIdo(m.ervenyes_eddig)}-ig, még ${hatra} percig.`,
  };
}

/** A frissen küldött meghívó lejárata, a sikerüzenethez. */
export function ujMeghivoLejarata(most: Date): string {
  return formatIdo(new Date(most.getTime() + MEGHIVO_ERVENYESSEG_PERC * 60_000).toISOString());
}

/** Az aktív tag, aki a meghívót már elfogadta, de a kétlépcsős azonosítást még nem állította be: leadet nem kap (`tag_kesz`). */
export const NEM_KESZ_SZOVEG = 'Nem kap leadet, amíg be nem állítja a kétlépcsős azonosítást.';

/** A jelzés szövege, vagy null. A függő meghívónál a meghívó-jelzés már megmondja a teendőt; ismeretlen készségnél (még nem töltött be) nincs jelzés. */
export function nemKeszJelzes(aktiv: boolean, meghivo: Meghivo | null, kesz: boolean | undefined): string | null {
  return aktiv && meghivo === null && kesz === false ? NEM_KESZ_SZOVEG : null;
}
